import Vue from "vue"
import {Participant} from "socket_if"

export default router => {
  return {
    namespaced: true,
    state: {
      userId: "",
      token: "",
      message: null,
      user: {},
      settings: []
    },
    getters: {
      id: state => state.userId,
      token: state => state.token,
      message: state => state.message,
      user: state => state.user,
      settings: state => state.settings,
      hasSetting: state => state.settings.indexOf(state.userId) !== -1,
      isAdmin: state => Participant.prototype.isAdmin.call(state.user),
      isGuest: state => Participant.prototype.isGuest.call(state.user)
    },
    mutations: {
      setUserId(state, userId) {
        if (!userId) return

        state.userId = userId
      },
      setToken(state, token) {
        if (!token) return

        state.token = token
      },
      setMessage(state, message) {
        state.message = message
      },
      setUser(state, user) {
        state.user = user
      },
      addSetting(state, settingId) {
        state.settings = _.union(state.settings, [settingId])
      },
      reset(state) {
        state.userId = ""
        state.token = ""
        localStorage.removeItem(Vue.prototype.$config.app.name)
      }
    },
    actions: {
      /**
       * ログイン処理
       * @param {object} context
       * @param {string} endpoint
       * @param {object} inputs
       * @param {object} validationObserver
       * @param {string} slug
       */
      async login(context, {endpoint, inputs, validationObserver, slug}) {
        const $axios = Vue.prototype.$axios
        await $axios
          .post(endpoint, inputs)
          .then(response => {
            const data = response.data
            context.commit("setUserId", `${data.account_type}_${data.account_id}`)
            context.commit("setToken", data.token)
            context.commit("setMessage", null)
            // axiosのリクエストにBearerトークンを設定
            $axios.resetToken()
            $axios.setToken(data.token)

            if (context.state.settings.indexOf(context.state.userId) === -1) {
              router.push({name: "Setting", params: {slug: slug}})
            } else {
              router.push({name: "Top", params: {slug: slug}}, () => {})
            }
          })
          .catch(error => {
            const data = error.response.data
            if (Object.prototype.hasOwnProperty.call(data, "message") && data.message) {
              context.commit("setMessage", data.message)
            }

            if (!Object.prototype.hasOwnProperty.call(data, "errors")) {
              this.commit("loading/setLoading", false)
              return
            }

            // サーバサイドのバリデーションをループで回す
            for (let [fieldName, messages] of Object.entries(data.errors)) {
              // VeeValidatorのnameが日本語なので、検索する
              const field = Object.entries(validationObserver.refs)
                .find(([_, input]) => input.fieldName === fieldName)
                .pop()

              // 対象フィールドがあるか判定
              if (field) {
                // responseのエラーメッセージを設定
                validationObserver.setErrors({[field.id]: messages})
              }
            }

            this.commit("loading/setLoading", false)
          })
      },
      /**
       * 自身の認証済みユーザ情報を取得
       * @param {object} context
       * @returns {Promise<void>}
       */
      async self(context) {
        const $axios = Vue.prototype.$axios
        await $axios
          .get("auth/self")
          .then(response => {
            context.commit("setUser", response.data.user)
          })
          .catch(error => {
            console.error(error)
            context.commit("reset")
            $axios.resetToken()
          })
      },

      /**
       * 対象のイベントの自身の認証済みユーザ情報を取得
       * @param context
       * @param slug
       * @return {Promise<void>}
       */
      async selfByEvent(context, slug) {
        const $axios = Vue.prototype.$axios
        await $axios
          .get(`auth/${slug}/self`)
          .then(response => {
            context.commit("setUser", response.data.user)
          })
          .catch(error => {
            console.error(error)
            context.commit("setUser", {})
          })
      },
      /**
       * ログアウト処理
       * deniedの場合は、403にリダイレクト
       *
       * @param {object} context
       * @param denied
       * @returns {Promise<void>}
       */
      async logout(context, denied) {
        const key = "tab"
        const local = Vue.prototype.$sl.get(key)
        const session = sessionStorage.getItem(key)

        // 有効なタブの場合のみログアウトを実施
        if (local === session) {
          const $axios = Vue.prototype.$axios
          await $axios
            .post("auth/logout")
            .then(response => {
              context.commit("setUser", {})
              context.commit("reset")
              $axios.resetToken()

              Vue.prototype.$socket.disconnect()

              if (denied) {
                router.push({name: "AccessDenied"})
              } else {
                router.push({name: "UserLogin", params: {slug: context.rootGetters["event/slug"]}})
              }
            })
            .catch(error => {
              console.error(error)

              if (denied) {
                router.push({name: "AccessDenied"})
              } else {
                router.push({name: "UserLogin", params: {slug: context.rootGetters["event/slug"]}})
              }
            })
        }
      },
      /**
       * アカウント情報の更新
       * @param context
       * @param endpoint
       * @param inputs
       * @param validationObserver
       * @param slug
       */
      async update(context, {endpoint, inputs, validationObserver, slug}) {
        const $axios = Vue.prototype.$axios
        await $axios
          .post(endpoint, inputs)
          .then(response => {
            context.commit("addSetting", context.getters["id"])

            router.push({name: "Top", params: {slug: slug}}, () => {})
          })
          .catch(error => {
            const data = error.response.data
            if (!Object.prototype.hasOwnProperty.call(data, "errors")) return

            // サーバサイドのバリデーションをループで回す
            for (let [fieldName, messages] of Object.entries(data.errors)) {
              // VeeValidatorのnameが日本語なので、検索する
              const field = Object.entries(validationObserver.refs)
                .find(([_, input]) => input.fieldName === fieldName || input.vid === fieldName)
                .pop()

              // 対象フィールドがあるか判定
              if (field) {
                // responseのエラーメッセージを設定
                validationObserver.setErrors({[field.id]: messages})
              }
            }

            this.commit("loading/setLoading", false)
          })
      }
    }
  }
}
